import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "sentence" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.randomParts, (part, index) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "part",
        key: index
      }, _toDisplayString(part) + _toDisplayString(index + 1 == _ctx.randomParts.length ? "." : " "), 1))
    }), 128))
  ]))
}